/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
// material
import {
    Stack,
    Container,
    Typography,
    Box,
    Card,
    Avatar,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
} from '@mui/material';
// components
// eslint-disable-next-line no-unused-vars
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import Page from '../../../components/Page';

// mock

import { UserAuth } from '../../../context/AuthContext';
import Utilisateurs from './composant/utilisateurs';
import Roles from './composant/roles';
import CustomButton from '../../../components/CustomButton';
import { db } from '../../../firebase.config';
import { useSnackbar } from '../../../context/snackbarContext';
import CustomConfirmationModal from '../../../components/customModal/confirmModal';


// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function ChangeOrgPage() {


    const { user, userData, logOut, initializing } = UserAuth();
    const navigate = useNavigate();
    const showSnackbar = useSnackbar();
    const [loading, setLoading] = useState(true);
    const [currentOrg, setCurrentOrg] = useState(null);
    const [organisations, setOrganisations] = useState([]);
    const [invitedOrgData, setInvitedOrgData] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    useEffect(() => {
        console.log('-----------------------------')
        const fetchData = async () => {
            console.log(userData)
            if (initializing) return;
            try {
                // Recuperer c'est donné orginateur
                const orgRef = doc(db, `organisateurs/${userData.uid}`);
                const orgSnap = await getDoc(orgRef);

                if (!orgSnap.exists()) {
                    showSnackbar("Invitation introuvable.", true);
                    // navigate("/");
                    return;
                }
                console.log(orgSnap.data())
                setCurrentOrg(userData.idOrg)
                const orgArray = orgSnap.data().idOrgs
                const array = []
                for (let index = 0; index < orgArray.length; index++) {
                    const id = orgArray[index];
                    const q = doc(db, 'organisations', id);
                    // eslint-disable-next-line no-await-in-loop
                    const querySnapshot = await getDoc(q);
                    array.push(querySnapshot)
                    console.log(querySnapshot.data())
                }
                setOrganisations(array)
                setLoading(false);
            } catch (error) {
                console.error("Erreur lors du chargement :", error);
                showSnackbar("Une erreur est survenue lors du chargement.", true);
                // navigate("/");
                setLoading(false);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [user, userData, initializing]);

    const handleAcceptInvitation = async () => {
        setOpenConfirmDialog(true);
    };



    const confirmAcceptInvitation = async () => {
        setLoading(true)
        try {
            const response = await fetch('https://us-central1-event-86cbf.cloudfunctions.net/changeOrganisation', {
                method: 'POST',
                body: JSON.stringify({
                    orgId: currentOrg,
                    userId: user.uid,
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();
            console.log(data)
            if (response.ok) {
                showSnackbar("Vous avez rejoint l'organisation avec succès !");
                navigate("/bo");
            } else {
                showSnackbar(data.error || "Une erreur est survenue lors du changement d'organisation.", true);
            }
        } catch (error) {
            console.error("Une erreur est survenue lors de l'acceptation :", error);
            showSnackbar("Une erreur est survenue.", true);
        } finally {
            setLoading(false)
        }
    };

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <CircularProgress />
            </Box>
        );
    }




    return (
        <Page title="Changer d'organisation">
            <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
                <Container sx={{ marginTop: { xs: 3 }, }}>
                    <Stack spacing={4} justifyContent={'center'} alignItems={'center'}>
                        <Typography textAlign='center' variant="h3" gutterBottom>
                            Vos organisations
                        </Typography>


                        <Grid container spacing={2} justifyContent="center">
                            {organisations.map((org, index) => (
                                <Grid
                                    key={org.id}
                                    item
                                    xs={6}
                                    md={3.5}
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setCurrentOrg(org.id); // si tu veux changer d'org
                                        setOpenConfirmDialog(false);
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundImage: `url(${org.data().bannerVisuel})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            backgroundColor: '#f2f2f2',
                                            height: '150px',
                                            display: 'flex',
                                            borderRadius: '7px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                backgroundColor: 'rgba(0, 0, 0, 0.40)',
                                                height: '150px',
                                                width: '100%',
                                                display: 'flex',
                                                padding: 5,
                                                borderRadius: '7px',
                                                alignItems: 'center',
                                                border: currentOrg === org.id ? '4px solid #5E17EB' : 'none',
                                            }}
                                        >
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="start"
                                                spacing={2}
                                                sx={{
                                                    width: '100%',
                                                    padding: 2,
                                                    marginX: { xs: 1, sm: 5 },
                                                }}
                                            >
                                                <Avatar src={org.data().idVisuel} sx={{ width: 80, height: 80 }} />
                                                <Stack direction="column" alignItems="start" justifyContent="center" >
                                                    <Typography variant="h5" gutterBottom sx={{ color: 'white' }}>
                                                        {org.data().nomOrg}
                                                    </Typography>
                                                </Stack>
                                            </Stack>
                                        </div>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>


                        <CustomButton type={'primaire'} buttonText={'Rejoindre'} onClick={handleAcceptInvitation} disabled={userData.idOrg === currentOrg}/>
                        <CustomConfirmationModal title={'Confirmation'} description={'Vous êtes sur le point de changer d\'organisation. voulez vous continuer ?'} open={openConfirmDialog} onClose={() => setOpenConfirmDialog(false)} onConfirm={() => confirmAcceptInvitation()}/>
                        
                    </Stack>

                </Container>
            </Box>
        </Page>
    );
}
